import React from "react";
import SlidingPane from "react-sliding-pane";
import { ReactComponent as CloseIcon } from "assets/svgs/close.svg";
import { useFilters } from "hooks/useStore";
import CollectionNavigation from "./navigation";
import Filters from "./filters";
import ClearAllFilters from "components/clear-filters";
import PriceRangeSlider from "components/price-range-slider";
import { SCREEN_SIZES } from "utils/constants";
import MediaQuery from "components/media-query";

const FiltersSlidePane = ({ navigation, filters, priceRange, handle, location, products }) => {
	const { isSlidePaneOpen, toggleSlidePane } = useFilters(["isSlidePaneOpen", "toggleSlidePane"]);

	return (
		<MediaQuery maxWidth={SCREEN_SIZES.lg}>
			<SlidingPane
				width="100%"
				from="bottom"
				className="z-50 overflow-y-auto !h-dvh !mt-0 lg:hidden"
				hideHeader
				overlayClassName="z-50"
				isOpen={isSlidePaneOpen}
				onRequestClose={toggleSlidePane}
			>
				<div className="flex justify-between items-center w-full mb-2 p-6 pb-1 sticky top-0 bg-white z-10">
					<ClearAllFilters handle={handle} />
					<button onClick={toggleSlidePane} className="bg-lightBeige p-3" aria-label="Filters">
						<CloseIcon className="size-5" />
					</button>
				</div>
				<div className="relative px-4 pb-6">
					<CollectionNavigation navigation={navigation} handle={handle} />
					<PriceRangeSlider
						handle={handle}
						minValue={priceRange.min}
						maxValue={priceRange.max}
						location={location}
					/>
					<Filters data={filters} handle={handle} products={products} />
				</div>
			</SlidingPane>
		</MediaQuery>
	);
};

export default FiltersSlidePane;